import { FloorplanKvm } from "@domain/project/floorplan/monitoring/floorplan-kvm";
import { FloorplanKvmReceiver } from "@domain/project/floorplan/monitoring/floorplan-kvm-receiver";
import { FloorplanWorkspaceKonvaAdapter } from "@project/floorplanner/konva/floorplan-workspace-konva.adapter";
import { IconKonva } from "@project/floorplanner/konva/icon-konva";
import { KvmReceiverKonva, KvmReceiverKonvaShapes } from "@project/floorplanner/konva/kvm-receiver-konva";
import { RemoteSensorWireKonva } from "@project/floorplanner/konva/remote-sensor-wire-konva";
import Konva from "konva";
import { Group } from "konva/lib/Group";

export interface KvmKonvaShapes {
  kvmGroup: Konva.Group;
  transmitter: Konva.Image;
}

export class KvmKonva {
  static init(
    kvm: FloorplanKvm,
    transmitterIcon: Konva.Image,
    warningSignIcon: Konva.Image,
    productGroup?: Konva.Group,
  ): KvmKonvaShapes {
    const group = new Konva.Group({
      id: kvm.id,
      [FloorplanWorkspaceKonvaAdapter.OBJECT_KEY]: kvm,
    });

    const iconGroup = IconKonva.init(kvm, transmitterIcon, warningSignIcon, productGroup);
    group.add(iconGroup);

    return { kvmGroup: group, transmitter: transmitterIcon };
  }

  static attachReceiver(
    receiver: FloorplanKvmReceiver,
    receiverIcon: Konva.Image,
    kvmGroup: Konva.Group,
  ): KvmReceiverKonvaShapes {
    const transmitterIcon = this.getTransmitterIcon(kvmGroup);
    const receiverShapes = KvmReceiverKonva.init(receiver, receiverIcon, transmitterIcon);
    const listenerNamespace = `.kvm-receiver-${receiver.id}`;

    transmitterIcon.on(`dragmove${listenerNamespace}`, () =>
      RemoteSensorWireKonva.updateWire(KvmReceiverKonva.getWire(receiverShapes.group), transmitterIcon, receiverShapes.receiver),
    );
    transmitterIcon.on(`transform${listenerNamespace}`, () =>
      RemoteSensorWireKonva.updateWire(KvmReceiverKonva.getWire(receiverShapes.group), transmitterIcon, receiverShapes.receiver),
    );

    receiverShapes.group.setAttr("listenerNamespace", listenerNamespace);
    kvmGroup.add(receiverShapes.group);
    return receiverShapes;
  }

  static detachReceiver(receiverGroup: Konva.Group, kvmGroup: Konva.Group): void {
    const transmitterIcon = this.getTransmitterIcon(kvmGroup);
    const listenerNamespace = receiverGroup.getAttr("listenerNamespace") as string | undefined;

    if (listenerNamespace) {
      transmitterIcon.off(`dragmove${listenerNamespace}`);
      transmitterIcon.off(`transform${listenerNamespace}`);
    }

    receiverGroup.destroy();
  }

  static getIconGroup(kvmGroup: Konva.Group): Group {
    return kvmGroup.getChildren()[0] as Group;
  }

  static getTransmitterIcon(kvmGroup: Konva.Group): Konva.Image {
    const iconGroup = kvmGroup.getChildren()[0] as Konva.Group;
    return iconGroup.getChildren()[1] as Konva.Image;
  }
}
